// import spotifyLogo from '../../assets/img/logo/spotify.svg'
import buycoffeeLogo from '../../assets/img/logo/buycoffee.svg'
import emailLogo from '../../assets/img/logo/email.svg'

export interface ContactItem {
	icon: string
	description: string
	email?: string
	link?: string
}

export const contactItems: ContactItem[] = [
	// {
	// 	icon: spotifyLogo,
	// 	description: 'Posłuchaj audiobooka',
	// 	link: 'https://open.spotify.com/show/3S7D5L8VB4C95CapykAvDq',
	// },
	{
		icon: buycoffeeLogo,
		description: 'Wesprzyj mnie',
		link: 'https://buycoffee.to/krzysztofkruk',
	},
	{
		icon: emailLogo,
		description: 'Napisz do mnie',
		email: 'krzychu@zuchy.com.pl',
	},
]